module.exports = __webpack_public_path__ + "img/female10.77061e17.jpg";